import _ from 'lodash';
import * as ActionTypes from '../actions/actionTypes';
import indicators from '../config/indicators';
import {getIntervals, getMostFrequentDuration} from '../utils/time_utils';

const _activeIndicator = (list) => {
  if (!list || list.length === 0) {
    return null;
  }

  const activeIndicators = list.filter((indicator) => indicator.active);

  if (activeIndicators.length === 0) {
    return null;
  }

  return activeIndicators[0];
};

const initialState = {
  indicators: _.sortBy(indicators, ['displayName']),
  active: _activeIndicator(indicators)
};

const reducer = (state = initialState, action) => {
  let newIndicators, newIndicator;
  switch (action.type) {

    case ActionTypes.POPULATE_INDICATOR_DETAILS:
      // Called by the action that has just contacted the server to get the meta-data for all of the layers.
      // We loop through each of the indicators, and if there is meta-data, mark it as available and store
      // the url to the metdata.
      newIndicators = state.indicators.map(value => {
        newIndicator = { ...value };

        // Configure empty available_times data
        if (!newIndicator.available_times) {
          newIndicator.available_times = {
            intervals: [],
            points: [],
            contained_points: {}
          };
        }

        const metadata_indicators = action.indicators;
        const matching_metadata_indicators =
          metadata_indicators.filter(metadata_indicator => metadata_indicator.prefix ===
                                                           (value.metadata_prefix || value.prefix));
        matching_metadata_indicators.forEach((metadata_indicator) => {
          newIndicator.available = true;
          newIndicator.metaLink = metadata_indicator.url;
          if (metadata_indicator.base) {
            newIndicator.base = metadata_indicator.base;
          }
          if (metadata_indicator.dim_issue_time) {
            newIndicator.dim_issue_time = metadata_indicator.dim_issue_time;
          }
        });
        return newIndicator;
      });
      return {
        indicators: newIndicators,
        active: _activeIndicator(newIndicators)
      };

    case ActionTypes.SWITCH_ACTIVE_INDICATOR:
      newIndicators = state.indicators.map((value) => {
        newIndicator = { ...value };
        newIndicator.active = false;
        if (newIndicator.prefix === action.indicator_prefix) {
          // If the source is a location change, it is always turning on the indicator, otherwise it is a toggle
          newIndicator.active = action.src_location_change ? true : !value.active;
        }
        return newIndicator;
      });
      return {
        indicators: newIndicators,
        active: _activeIndicator(newIndicators)
      };

    case ActionTypes.UPDATE_INDICATOR_TIMES:
      // Called by an action that is making sure the metadata for a single indicator is up to date.
      newIndicators = state.indicators.map((value) => {
        newIndicator = { ...value };
        if (newIndicator.prefix === action.indicator_prefix) {
          newIndicator.creationTime = newIndicator.use_import_time_over_creation_time ?
                                      action.importTime :
                                      action.creationTime;
          newIndicator.importTime = action.importTime;
          newIndicator.dataSource = action.dataSource;
          let intervals;
          if (action.timeless) {
            // Create a 9 day validity (916 hours)
            newIndicator.most_frequent_duration = 'PT916H';
            intervals = getIntervals([action.validTimes[0]], newIndicator.most_frequent_duration, action.validTimes);
            // For AFDRS, we need to set a specific time for the WMS time.
            if (action.times && action.times.length === 1) {
              intervals.interval_objects[0].point_at = action.times[0];
              intervals.valid_points[0] = action.times[0];
            }
          } else {
            newIndicator.most_frequent_duration = getMostFrequentDuration(action.times);
            intervals = getIntervals(action.times, newIndicator.most_frequent_duration, action.validTimes);
          }
          newIndicator.available_times = {
            points: intervals.valid_points,
            contained_points: intervals.all_valid_periods,
            intervals: intervals.interval_objects
          };
        }
        return newIndicator;
      });
      return {
        indicators: newIndicators,
        active: _activeIndicator(newIndicators)
      };

    case ActionTypes.RESET_LAYERS:
      newIndicators = state.indicators.map((value) => {
        newIndicator = { ...value };
        newIndicator.active = false;
        return newIndicator;
      });
      return {
        indicators: newIndicators,
        active: null
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/indicators.js